import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    transfersListAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for the transfers list */
            transfersListAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploaderSheetList.transfersListAriaLabel?c=1pzb7ccp2ludu", defaultMessage: "Transfers" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
